<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      Changelog
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0; max-height: 65vh; overflow: auto">
    <markdown [src]="'/assets/CHANGELOG.md'" />
  </mat-card-content>

  <mat-divider />

  <!-- Botones -->
  <mat-card-actions class="gap-3" style="margin: 0.5em">
    <mat-checkbox [(ngModel)]="noMostrar" class="mr-3">
      No volver a mostrar
    </mat-checkbox>
    <button mat-raised-button type="button" (click)="cerrar()">
      Cerrar
    </button></mat-card-actions
  >
</mat-card>
